/**
 * @description 提取弹窗
 */

import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerTitleHeader } from "@/components/ui/drawer";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { mul } from "@/libs/decimal";
import { useMemo } from "react";

export enum WalletEnum {
  deposit = 1,
  withdraw = 2,
  bonus = 3,
}

export interface ClaimProps {
  /** @des 金额 */
  amount: number;
  currency: string;
  claimAmount?: number;
  claimCurrency?: string;
  rewards: {
    money: {
      amount: number;
      currency: string;
    };
    wallet: {
      type: WalletEnum;
      water_multiple: number;
    };
    type: 'loss_return' | 'weekly_reward' | 'upgrade_reward' | 'monthly_reward' | 'daily_reward' | 'calendar_reward';
  }[];
}

const ClaimDrawer = NiceModal.create<ClaimProps>((props) => {
  const { amount, currency, claimAmount, claimCurrency, rewards } = props;
  const modal = useModal();
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t = useTranslations('reward');
  const t_referral = useTranslations('referral');
  const t_cumulative = useTranslations('cumulative-recharge');

  // 是否是USDT用户
  const isUsdtUser = useMemo(() => {
    return currency !== claimCurrency;
  }, [currency, claimCurrency]);

  return (
    <Drawer open={modal.visible} onOpenChange={(open) => !open && modal.hide()}>
      <DrawerContent className="bg-surface border-none rounded-t-[10px] text-xs text-tertiary min-h-[30vh] font-medium">
        <DrawerTitleHeader title={t_cumulative('congratulations')} showClose={true} />
        <div className="pb-7 px-3">
          <div className="bg-dark-special rounded-lg py-6 text-center">
            <div className="text-3xl text-white font-semibold flex flex-col items-center">
              <div>{formatCurrencyDetail(amount)}&nbsp;{currency}</div>
            </div>
            <div className="flex items-center justify-center mt-3">
              {
                isUsdtUser && (
                  <div className="text-secondary text-s font-medium">≈{formatCurrencyDetail(claimAmount || 0)}&nbsp;{claimCurrency}&nbsp;</div>
                )
              }
              <div className="text-accent-green">{t('claimed')}</div>
            </div>
          </div>
          <div className="mt-5">
            <div className="space-y-4">
              {/* 遍历rewards */}
              {rewards?.map((item, i) => {
                const isCalenderReward = item?.type === 'calendar_reward';
                const claimToWhat = isCalenderReward ? t('claimToCalendar') : [WalletEnum.deposit, WalletEnum.withdraw].includes(item?.wallet?.type) ? t('claimToWallet') : t('claimToReward');
                return (
                  <div className="flex items-start justify-between" key={i}>
                    <div className="whitespace-nowrap">{claimToWhat}</div>
                    <div className="flex flex-col items-end">
                      <div className="text-secondary">{formatCurrencyDetail(item?.money?.amount)}&nbsp;{item?.money?.currency}</div>
                      {!isCalenderReward && !!Number(item?.wallet?.water_multiple) && (
                        <div className="mt-2.5 flex items-center whitespace-nowrap">
                          {t('turnoverRequirement', { amount: `${formatCurrencyDetail(mul(item?.wallet?.water_multiple, item?.money?.amount))} ${item?.money?.currency}` })}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <Button variant='primary' className="w-full mt-8" onClick={() => modal.hide()}>{t_referral('ok')}</Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

export default ClaimDrawer;

export const showClaimDrawer = (props: ClaimProps) => {
  return NiceModal.show(ClaimDrawer, props as any);
};

export const hideClaimDrawer = () => {
  return NiceModal.hide(ClaimDrawer);
};